import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { AnalysisCommentsVM } from './AnalysisCommentsVM';
import { formatDate } from 'cd-eft/utils/formatDate';
import { Form, FormGroup, Label, Col } from 'reactstrap';
import { ActionsMenu } from '../../Design/common/ActionsMenu';
import stores from 'cd-eft/models/Stores';
import { DesignCommentAdd, DesignCommentCloseButtons, DesignCommentDeletePopup, DesignCommentEditForm, DesignCommentReadAndEdit, DesignCommentReadForm } from '../common/CommentInputs';
const libraryStore = stores.AppStore.projectsLibraryStore;

const AnalysisCommentsComponent = (props) => {
    const vm = useRef(new AnalysisCommentsVM(props)).current;

    return (
        <>
            <div className="sub-container">
                <div className="action-menu-wrapper">
                    <ActionsMenu i={'analysis-comments'} item="item" colorWhite={true} elementActions={vm.elementActions}>Action</ActionsMenu>
                </div>
                <div className="comments-container">
                    {libraryStore.analysisComments.length === 0 && !vm.addFormActive && (
                        <div className="no-comment">
                            <p>No Design Comment</p>
                        </div>
                    )}
                    {/********************  Create Comments Form   ********************/}
                    {vm.addFormActive && (
                        <Form
                            fluid={+true}
                            onSubmit={vm.handleSubmit}
                        >
                            <FormGroup>
                                <DesignCommentAdd
                                    selectId={'workflowstep'}
                                    defaultValue={vm.createDesignCommentForm.workflowstep}
                                    onChange={vm.handleInput}
                                    addOrEdit={'add'}
                                    errorClassFunction={vm.errorClass}
                                    label={'Select Workflow step'}
                                    optionList={libraryStore.workFlowStep.analysis}
                                    validationArray={vm.formValidation.formErrors}
                                />
                                <Col>
                                    <Label for="createdBy">
                                        <div className="info">
                                            <div className="workflowstep">
                                                <strong>{vm.createDesignCommentForm.workflowstep}</strong>
                                            </div>
                                            <div className="name capitalize">
                                                <strong>{vm.createDesignCommentForm.commentAuthor.split('@')[0].replace('.', ' ')}</strong>
                                            </div>
                                            <div className="date">{formatDate(Date.now())}</div>
                                        </div>
                                    </Label>
                                </Col>
                                <Col>
                                    <textarea
                                        className={`comment-textarea ${vm.errorClass('projectComment')}`}
                                        name="projectComment"
                                        value={vm.createDesignCommentForm.projectComment}
                                        placeholder="add comment"
                                        autoFocus
                                        onChange={vm.handleInput}
                                        rows={4}
                                        wrap="soft"
                                    />
                                    <span className="usa-error-message" id="projectComment-error--message" role="alert">
                                        <div>{vm.formValidation.formErrors['projectComment']}</div>
                                    </span>
                                </Col>
                            </FormGroup>
                        </Form>
                    )}
                    {vm.addFormActive && (
                        <div className="d-flex justify-content-end usa-buttons">
                            <button className="usa-button usa-button--outline" onClick={vm.cancelComment}>
                                Close
                            </button>
                            <button className="usa-button" onClick={vm.createComment} disabled={vm.isSaving}>
                                Save
                            </button>
                        </div>
                    )}
                    {/********************  End of Create Comments Form   ********************/}

                    {libraryStore.analysisComments &&
                        libraryStore.analysisComments.map((comment, i) => {
                            return (
                                <DesignCommentReadAndEdit
                                    vm={vm}
                                    comment={comment}
                                    index={i}
                                    readFormVarName='workflowStep'
                                    DesignCommentAddProps={{
                                        selectId: 'workflowstep',
                                        defaultValue: comment.workflowStep,
                                        onChange: (e) => { vm.handleInputChange(e, i) },
                                        addOrEdit: 'edit',
                                        errorClassFunction: vm.errorClass,
                                        label: 'Select Workflow step',
                                        optionList: libraryStore.workFlowStep.analysis,
                                        validationArray: vm.formValidation.formErrors
                                    }}
                                />
                            );
                        })
                    }
                </div>
                <DesignCommentCloseButtons vm={vm} />

                {/********************  End of Edit Comments Form   ********************/}

                {/********************  Delete Comments Popup   ********************/}
                <DesignCommentDeletePopup
                    vm={vm}
                    commentList={libraryStore.analysisComments}
                    nameHeader='Workflow step'
                />
                {/********************  Delete Comments Popup   ********************/}
            </div>
            {/*                     </Accordion>
                </div>
            )} */}
        </>
    );
};
export const AnalysisComments = observer(AnalysisCommentsComponent);
